enum Feature {
  PAYMENT_GATEWAY = 1,
  ONEWAY_RENTAL_CHARGE = 2,
  CODE_SEQUENCE_EDITABLE = 3,
  CUSTOM_CONTRACT_WORKFLOW = 4,
  AI_CALL_AGENT = 5,
  AI_LICENSE_SCAN = 6,
  ACCOUNTING = 7,
  EMAIL_PARSING = 8,
  OUTBOUND_CALL = 9,
  STRIPE_VERIFICATION = 10,
  BONZAH_INSURANCE = 11,
  DRIVER_FOR_RENTAL = 12,
  PAYMENT_DEPOSIT = 13,
  UNLIMITED_MILEAGE = 14,
  EXTRA_RENTAL_DAY = 15,
  CUSTOM_VALIDATION_RULES = 16,
}

export default Feature;
